/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IRProducao } from '../../../shared/services/api/rh/Produtividade/ProdutividadeService';
import moment from 'moment';

async function RelatorioProdutividade(dados: IRProducao[], fazenda: string, periodo: string) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const nf = new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const colaboradores = new Set(dados.map((row) => row.nome)).size;
  const totalQtd = dados.reduce((acc, row) => acc + row.qtd, 0);
  const totalAdicional = dados.reduce((acc, row) => acc + row.vladicional, 0);
  const totalAtividade = dados.reduce((acc, row) => acc + row.vlatividade, 0);
  const totalGeral = dados.reduce((acc, row) => acc + row.total, 0);

  const rows = dados.map((row, index) => {
    const fillColor = index % 2 === 0 ? undefined : '#f5f5f5';
    return [
      { text: moment(row.datalan).format('DD/MM/YYYY'), fontSize: 8, alignment: 'center', fillColor },
      { text: row.nome, alignment: 'left', fontSize: 8, fillColor },
      { text: row.descricao, alignment: 'left', fontSize: 8, fillColor },
      { text: row.pivot, alignment: 'left', fontSize: 8, fillColor },
      { text: nf.format(row.meta), alignment: 'right', fontSize: 8, fillColor },
      { text: nf.format(row.qtd), alignment: 'right', fontSize: 8, fillColor },
      { text: nf.format(row.vladicional), alignment: 'right', fontSize: 8, fillColor },
      { text: nf.format(row.vlatividade), alignment: 'right', fontSize: 8, fillColor },
      { text: nf.format(row.total), alignment: 'right', fontSize: 8, fillColor },
    ];
  });

  const summaryRow = [
    { text: 'Colaboradores: ' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0 }).format(colaboradores), colSpan: 5, alignment: 'left', fontSize: 9, bold: true, fillColor: '#dddddd', border: [false, true, false, false] },
    { text: '', border: [false, false, false, false] },
    { text: '', border: [false, false, false, false] },
    { text: '', border: [false, false, false, false] },
    { text: '', border: [false, false, false, false] },
    { text: nf.format(totalQtd), alignment: 'right', fontSize: 9, bold: true, fillColor: '#dddddd' },
    { text: nf.format(totalAdicional), alignment: 'right', fontSize: 9, bold: true, fillColor: '#dddddd' },
    { text: nf.format(totalAtividade), alignment: 'right', fontSize: 9, bold: true, fillColor: '#dddddd' },
    { text: nf.format(totalGeral), alignment: 'right', fontSize: 9, bold: true, fillColor: '#dddddd' },
  ];

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  let imageData: string | null = null;
  try {
    const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
    const data = await getBase64ImageFromUrl(imageUrl);
    if (data.startsWith('data:image')) {
      imageData = data;
    }
  } catch (error) {
    console.warn('Não foi possível carregar o logotipo do relatório, gerando sem imagem.', error);
  }

  const empresaInfo = [
    [
      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF', alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false] },
    ],
    [
      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
    ],
  ];

  const headerTable = imageData
    ? {
      table: {
        widths: [48, 760],
        body: [
          [
            { image: imageData, width: 48, border: [false, false, false, false] },
            {
              border: [false, false, false, false],
              table: { widths: [720], body: empresaInfo }
            },
          ],
          [
            { text: 'Relatório de Produtividade Diaria', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
            {}
          ]
        ]
      }
    }
    : {
      table: {
        body: [
          [
            {
              border: [false, false, false, false],
              table: { widths: [548], body: empresaInfo }
            },
          ],
          [
            { text: 'Relatório de Produtividade Diaria', margin: [5, 10, 0, 0], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
          ]
        ]
      }
    };

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [10, 30, 30, 20],
    header: '',
    pageOrientation: 'landscape',
    footer: (currentPage: number, pageCount: number) => ({
      columns: [
        { text: `Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`, alignment: 'left', fontSize: 8, margin: [10, 0, 0, 0] },
        { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', fontSize: 8, margin: [0, 0, 30, 0] },
      ],
    }),
    content: ([
      headerTable,
      { text: `Fazenda: ${fazenda}    |    Período: ${periodo}`, alignment: 'center', fontSize: 13 },
      {
        table: {
          widths: [45, 200, 200, 50, 33, 50, 50, 50, 50],
          headerRows: 1,
          body: [
            [
              { text: 'Data', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Nome', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Atividade', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Pivot', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Meta', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Quan.', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'V. Adicional', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'V. Atividade', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
              { text: 'Total', style: 'tableHeader', alignment: 'center', fillColor: '#dddddd', fontSize: 8 },
            ],
            ...rows,
            summaryRow,
          ]
        },
      },

    ]),

  };
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}
export default RelatorioProdutividade;
